<template>
  <svg
    viewBox="0 0 22 20"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9125 1.12568L21.7055 16.6692C21.8983 17.0066 21.9999 17.3893 22 17.7788C22.0001 18.1684 21.8987 18.5512 21.7061 18.8887C21.5134 19.2262 21.2362 19.5065 20.9023 19.7016C20.5685 19.8966 20.1897 19.9995 19.804 19.9999H2.21803C1.83048 20.0034 1.44891 19.9034 1.11197 19.7099C0.77504 19.5165 0.494727 19.2365 0.299448 18.8983C0.104168 18.5602 0.000863625 18.1759 5.39148e-06 17.7844C-0.000852843 17.3929 0.100766 17.0082 0.294561 16.6692L9.08755 1.12568C9.27928 0.783948 9.55731 0.499706 9.89329 0.301949C10.2293 0.104193 10.6112 0 11 0C11.3889 0 11.7708 0.104193 12.1068 0.301949C12.4427 0.499706 12.7208 0.783948 12.9125 1.12568ZM12 7C12 6.44772 11.5523 6 11 6C10.4477 6 10 6.44772 10 7V11C10 11.5523 10.4477 12 11 12C11.5523 12 12 11.5523 12 11V7ZM11 14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H11.01C11.5623 16 12.01 15.5523 12.01 15C12.01 14.4477 11.5623 14 11.01 14H11Z"
    />
  </svg>
</template>
